import { render, staticRenderFns } from "./MailCompose.vue?vue&type=template&id=51dda9a5&scoped=true"
import script from "./MailCompose.vue?vue&type=script&lang=js"
export * from "./MailCompose.vue?vue&type=script&lang=js"
import style0 from "./MailCompose.vue?vue&type=style&index=0&id=51dda9a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dda9a5",
  null
  
)

export default component.exports